// Funciones de utilidad para el componente Quiz
import { API_BASE_URL } from '../config/apiConfig';

// Función para manejar el clic en cualquier parte de la página
export const handleClick = (respuestaRevelada, respuestasVisibles, setRespuestasVisibles) => {
  return (event) => {
    if (!respuestaRevelada && respuestasVisibles < 4) {
      if (!event.target.classList.contains('respuesta-visible') && !event.target.closest('.respuesta-visible')) {
        setRespuestasVisibles(prev => Math.min(prev + 1, 4));
      }
    }
  };
};

// Función para terminar el concurso
export const terminarConcurso = async (setJuegoTerminado, preguntasMostradasIds = []) => {
  try {
    // Obtener el ID del concurso actual desde sessionStorage
    let concursoId = sessionStorage.getItem('concurso_id');
    console.log('Intentando terminar concurso con ID:', concursoId);

    // Si no se encuentra en sessionStorage, intentar obtenerlo de otra manera temporalmente
    if (!concursoId) {
      // Buscar el ID del concurso en los datos de preguntas almacenados
      const preguntasConcurso = sessionStorage.getItem('preguntasConcurso');
      if (preguntasConcurso) {
        try {
          const preguntas = JSON.parse(preguntasConcurso);
          if (preguntas && preguntas.length > 0) {
            // Suponiendo que la primera pregunta tiene el ID del concurso como parte de su información
            // Esto es una solución temporal hasta que se corrija la lógica principal
            console.log('Se encontraron preguntas en sessionStorage, pero no se puede determinar el ID del concurso directamente');
          }
        } catch (e) {
          console.error('Error al parsear preguntasConcurso:', e);
        }
      }

      // Solución temporal: llamar a la API sin ID, dejando que el backend maneje la lógica de encontrar el concurso activo
      console.warn('No se encontró el ID del concurso en sessionStorage, llamando a la API sin ID específico');
      console.warn('Contenido actual de sessionStorage:', sessionStorage.getItem('concurso_id'));
      console.warn('Todos los items en sessionStorage:');
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        console.log(key + ':', sessionStorage.getItem(key));
      }

      // Llamar a la API para terminar el concurso, permitiendo que el backend identifique el concurso activo
      const response = await fetch(`${API_BASE_URL}/terminar_concurso.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ preguntas_mostradas_ids: preguntasMostradasIds })
      });

      const result = await response.json();
      console.log('Respuesta de la API:', result);

      if (result.success) {
        console.log('Concurso terminado exitosamente en la base de datos');
        console.log('Detalles:', result);
      } else {
        console.error('Error al terminar el concurso en la base de datos:', result.error);
        console.error('Detalles del error:', result);
      }
    } else {
      // Llamar a la API para terminar el concurso en la base de datos
      const response = await fetch(`${API_BASE_URL}/terminar_concurso.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          concurso_id: parseInt(concursoId),
          preguntas_mostradas_ids: preguntasMostradasIds
        })
      });

      const result = await response.json();
      console.log('Respuesta de la API:', result);

      if (result.success) {
        console.log('Concurso terminado exitosamente en la base de datos');
        console.log('Detalles:', result);
      } else {
        console.error('Error al terminar el concurso en la base de datos:', result.error);
        console.error('Detalles del error:', result);
      }
    }
  } catch (error) {
    console.error('Error al intentar terminar el concurso:', error);
  } finally {
    setJuegoTerminado(true);
  }
};

// Función para reiniciar el concurso completo
export const reiniciarConcursoCompleto = (reiniciarConcurso, resetComodines, setRespuestasVisibles, setFallos) => {
  // Reinicia el concurso manteniendo las mismas preguntas y reiniciando los comodines
  reiniciarConcurso(resetComodines);
  setRespuestasVisibles(0);
  if (setFallos) setFallos(0);
};
